<div class="flex w-full h-full">
  <div class="w-2/3">
    <div class="h-full bg-blue-300">
      <img
        class="w-full h-full opacity-70"
        src="../../../../assets/img/hero-slide-desarrollos.jpg"
        alt="Imagen"
      />
    </div>
  </div>
  <div class="w-1/3 px-5 h-[100vh] flex items-center bg-white">
    <div class="flex justify-center w-full h-26">
      <dx-form
        [formData]="user"
        [readOnly]="false"
        [showColonAfterLabel]="true"
        [showValidationSummary]="true"
        validationGroup="customerData"
      >
        <dxi-item itemType="group">
          <dxi-item>
            <div class="flex justify-center" *dxTemplate>
              <img
                class="h-16"
                src="https://ekisa.com.co/assets/icons/ekisa-logo-negro.png"
              /></div
          ></dxi-item>
          <dxi-item>
            <div *dxTemplate class="mt-2 text-center">
              <h1>¡Bienvenido de nuevo!</h1>
              <p class="login-text">
                Inicia sesión para acceder a las características.
              </p>
            </div>
          </dxi-item>

          <dxi-item
            dataField="usuario"
            [editorOptions]="{ stylingMode: 'filled' }"
          >
            <dxo-label text="Usuario"></dxo-label>
            <dxi-validation-rule
              type="required"
              message="Usuario es requerido"
            ></dxi-validation-rule>
          </dxi-item>

          <dxi-item
            dataField="password"
            [editorOptions]="{
              mode: 'password',
              stylingMode: 'filled'
            }"
          >
            <dxo-label text="Contraseña"></dxo-label>
            <dxi-validation-rule
              type="required"
              message="Contraseña es requerida"
            ></dxi-validation-rule>
          </dxi-item>
        </dxi-item>

        <dxi-item itemType="group">
          <dxi-item
            itemType="button"
            horizontalAlignment="center"
            [buttonOptions]="{
              type: 'default',
              text: 'Ingresar',
              width: '100%',
              height: 50,
              onClick: onSubmit
            }"
          >
          </dxi-item>
        </dxi-item>

        <dxi-item>
          <div *dxTemplate class="mt-2 text-center">
            <p class="login-text">
              Sistema desarrollado por
              <a href="https://ekisa.com.co" target="_blank"> Ekisa S.A.S </a>
            </p>
          </div>
        </dxi-item>
      </dx-form>
    </div>
  </div>
</div>
